import { Money } from '@rygen/rygen-ui/model';

export class CreditUsage {
  standing?:
    | 'NO_LIMIT_CONFIGURED'
    | 'GOOD_STANDING'
    | 'APPROACHING_LIMIT'
    | 'LIMIT_EXCEEDED';
  outstandingBalance?: Money;
  creditLimit?: Money;
  warningThreshold?: number;
  limitExceeded?: boolean;
  limitConfigured?: boolean;

  constructor(opts?: Partial<CreditUsage>) {
    if (opts?.standing != null) {
      this.standing = opts.standing;
    }
    this.outstandingBalance = opts?.outstandingBalance
      ? new Money(opts.outstandingBalance)
      : undefined;
    this.creditLimit = opts?.creditLimit
      ? new Money(opts.creditLimit)
      : undefined;
    if (opts?.warningThreshold != null) {
      this.warningThreshold = opts.warningThreshold;
    }
    if (opts?.limitExceeded != null) {
      this.limitExceeded = opts.limitExceeded;
    }
    if (opts?.limitConfigured != null) {
      this.limitConfigured = opts.limitConfigured;
    }
  }
}
